const locale = {
  WELCOME_TO_ALLPASS: '',
  WELCOME_DESCRIPTION: '',
};

export default locale;
